import { toDateTimeStr } from '@mi-front/core';
import { ModalStateProps } from '@mi-front/ui';
import { MatchesAddPage } from '../../screens/matches-add/MatchesAddPage';
import {
  useClearCursor,
  useCursor,
} from '../../../../../logger/screens/stream/stores/stream-screen.store';
import { useRangeAuditResults } from '../../../../../logger/screens/stream/components/audit/useRangeAuditResults';
import { useActiveStation } from '../../../../../../core/stations/hooks/useActiveStation';

export function MatchAddFromCursor(p: ModalStateProps) {
  const station = useActiveStation();
  const ts = useCursor();
  const clearCursor = useClearCursor();
  const { reload: reloadMatches } = useRangeAuditResults();

  if (!ts) {
    return null;
  }

  return (
    <MatchesAddPage
      station={station}
      datetime={toDateTimeStr(ts)}
      onSuccess={() => {
        reloadMatches();
        clearCursor();
      }}
      {...p}
    />
  );
}
